import { Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import StyledBox from './WeightCell.styles';

interface WeightCellProps {
  value: number;
}

export default function WeightCell({ value }: WeightCellProps) {
  const initValue = React.useMemo(() => value, [value]);
  const { t } = useTranslation('compliance-operation');

  return (
    <StyledBox style={{ cursor: 'default' }}>
      <Typography className="label">{t('logic.weight-label')}</Typography>
      <Typography className="value">{initValue}</Typography>
    </StyledBox>
  );
}
